const PASSTHROUGH_REPLACEMENTS: ReadonlyArray<readonly [RegExp, string]> = [
  [/%20/g, '+'],
  [/%26/g, '&'],
  [/%28/g, '('],
  [/%29/g, ')'],
  [/%3A/gi, ':'],
  [/%40/g, '@'],
];

export const encodeUrlValue = (raw: string): string => {
  let encoded = encodeURIComponent(raw);
  for (const [pattern, replacement] of PASSTHROUGH_REPLACEMENTS) {
    encoded = encoded.replace(pattern, replacement);
  }
  return encoded;
};

export const decodeUrlValue = (segment: string): string => {
  const spaced = segment.replace(/\+/g, ' ');
  try {
    return decodeURIComponent(spaced);
  } catch {
    return spaced;
  }
};
